<template>
    <b-container fluid>
        <b-row>
            <b-col>
                <label for="commitments">Compromisos del evaluado</label>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-card>
                    <div style="height: 150px; overflow: auto;">
                        <p><span v-html="commitment"></span></p>
                    </div>
                </b-card>
            </b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col>
                <b-form-checkbox switch
                    v-model="approveCommitment"
                    unchecked-value="No aprueba"
                    value="Aprueba"
                >
                Aprueba o desaprueba
                </b-form-checkbox>
            </b-col>
            <b-col>
                Estado actual: <strong>{{ approveCommitment }}</strong>
            </b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col>
                <app-form-textarea-input label='Adicionar comentarios' v-model="qualificationComments">
                </app-form-textarea-input>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
export default {
    data:() =>({
        commitment: '',
        qualificationComments: '',
        approveCommitment: 'No aprueba',
        evaluationMember: []
    }),
    methods:{
        fillCommitments(evaluationMember){
            this.evaluationMember = evaluationMember
            this.commitment = evaluationMember[0].commitments
        },
        async saveQualification(){
            var evaluationId = this.evaluationMember[0].performance_evaluation_id
            const params = {
                evaluatedId: this.evaluationMember[0].evaluated_id,
                qualificationComment: this.qualificationComments,
                approveCommitment: this.approveCommitment == 'Aprueba'? true: false
            }
            const {data} = await repo.post(`performance-evaluations/${evaluationId}/store-commitment-qualification`,{
                ...params
            })
            if(data.status){
                this.$emit('saved-qualification',data)
            }else{
                this.$emit('error',data)
            }
        }
    }
}
</script>